import { apiRequest } from "./httpClient";

export async function searchMusic(username, token, query) {
    return apiRequest("api/music/search", { token, body: { username, query } });
}
